export const ARROW_DOWN = 40;
export const ARROW_UP = 38;
export const BACKSPACE = 8;
export const COMMAND = 91;
export const CTRL = 17;
export const ENTER = 13;
export const ESCAPE = 27;
export const SHIFT = 16;
export const SPACE = 32;
export const TAB = 9;

// Letters
export const CEE = 67;

export const ENTER_STRING = 'Enter';
export const KEY_ENTER = [ENTER_STRING];
export const KEY_ESCAPE = ['Escape'];

export const ESCAPE_LITERAL = 'esc';
